import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import axios from '../../../../config/axios'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import { useNavigate } from 'react-router-dom'
import PricesDisplay from '../../../../components/PricesDisplay'
import LoadMoreButton from '../../../../components/LoadMoreButton'

interface Resource {
  id: number
  name: string
  code?: string
  type: { id: number; name: string } | null
  category: { id: number; name: string } | null
  pricePerKg: number
  prices?: Array<{
    id: number
    price: string
    unitOfMeasurement: {
      id: number
      name: string
    }
  }>
  description: string
  suppliers: {
    id: number
    companyName: string
    cnpj: string
  }[]
}

const ResourcesTable: React.FC = () => {
  const [resources, setResources] = useState<Resource[]>([])
  const [visibleCount, setVisibleCount] = useState<number>(10)
  const navigate = useNavigate()

  useEffect(() => {
    const getResources = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/resources/resource`, {
          params: {
            limit: visibleCount,
            offset: 0,
          }
        })
        if (response.data) setResources(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    getResources()
  }, [visibleCount])

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Insumo</Th>
          <Th>Categoria</Th>
          <Th>Tipo</Th>
          <Th>Código</Th>
          <Th>Preço</Th>
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {resources.map((resource, index) => (
          <Tr key={index}>
            <Td>{resource.name}</Td>
            <Td>{resource.category?.name || 'N/A'}</Td>
            <Td>{resource.type?.name || 'N/A'}</Td>
            <Td>{resource.code || 'N/A'}</Td>
            <Td>
              <PricesDisplay prices={resource.prices || [] as any} maxWidth={200} />
            </Td>
            <TdButtons>
              <img src={lookup} alt='lookup' onClick={() => navigate(`view?id=${resource.id}`)} />
            </TdButtons>
          </Tr>
        ))}
      </tbody>
      <tfoot>
        <FooterTr>
          <Td colSpan={6} style={{ textAlign: 'center', background: 'transparent' }}>
            <LoadMoreButton
              onLoadMore={() => setVisibleCount(prev => prev + 10)}
              hasMore={false}
              currentCount={resources.length}
              totalCount={resources.length}
            />
          </Td>
        </FooterTr>
      </tfoot>
    </GlobalTable>
  )
}

export default ResourcesTable
